module.exports = __webpack_public_path__ + "media/images/shared/icon_slider_next-ab3020f7bb5d56f57f289264dc7eb074.png";